import { REGISTER_FAILED, REGISTER_REQUEST, REGISTER_SUCCESS, REGISTER_CLEAR } from '../../actions/register';

const initialState = {
    user: null,
    registering: false,
    error: null
}

export const register = (state = initialState, action) => {
    switch (action.type) {
        case REGISTER_REQUEST:
            return Object.assign({}, state, {
                user: null,
                registering: true,
                error: null
            })
        case REGISTER_FAILED:
            return Object.assign({}, state, {
                user: null,
                registering: false,
                error: action.error
            })
        case REGISTER_SUCCESS:
            return Object.assign({}, state, {
                user: action.payload.data.payload,
                registering: false,
                error: null
            })
        case REGISTER_CLEAR:
            return Object.assign({}, state, {
               user: null,
               registering: false,
               error: null 
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/user/register.js